(function () {
  'use strict';

  const breakpointStrategies = {
    'complementary-products': () => ({
      0: { slidesPerView: 2.2, spaceBetween: 15 },
      480: { slidesPerView: 2.2, spaceBetween: 15 },
      768: { slidesPerView: 2, spaceBetween: 15 },
      1024: { slidesPerView: 2.1, spaceBetween: 15 },
      1400: { slidesPerView: 3, spaceBetween: 15 },
    }),
    default: ({ spacing, columns, tabletColumns, mobColumns }) => ({
      0: { slidesPerView: 'auto', spaceBetween: 15 },
      601: { slidesPerView: mobColumns, spaceBetween: 15 },
      640: { slidesPerView: 2, spaceBetween: spacing },
      768: { slidesPerView: tabletColumns, spaceBetween: spacing },
      1280: { slidesPerView: columns, spaceBetween: spacing },
      1400: { slidesPerView: columns, spaceBetween: spacing },
    }),
  };

  /** Owns slider resources, including initialization deferred until the library loads. */
  class RecommendationSlider {
    constructor({ getSwiper = () => window.Swiper, eventTarget = document,
      schedule = (...args) => setTimeout(...args), cancel = handle => clearTimeout(handle), strategies = breakpointStrategies } = {}) {
      Object.assign(this, { getSwiper, eventTarget, schedule, cancel, strategies });
    }

    mount(host, options) {
      this.destroy();
      const inner = host.querySelector('.product_recommendations_inner, .complementary_products_inner');
      if (!inner) return;
      this.inner = inner;
      inner.swiper?.destroy(true, true);
      const previous = host.querySelector('.pr_prev');
      const next = host.querySelector('.pr_next');
      const complementary = options.type === 'complementary-products';
      const pagination = (complementary && host.querySelector('.complementary-products_swiper-pagination')) ||
        host.querySelector('.rec-swiper-pagination');
      const strategy = this.strategies[options.type] || this.strategies.default;
      let checks = 0;
      const initialize = () => {
        if (this.onReady !== initialize || this.inner !== inner || !host.isConnected) return;
        this.cancel(this.timer);
        const Swiper = this.getSwiper();
        if (!Swiper) {
          if (++checks < 300) this.timer = this.schedule(initialize, 50);
          else {
            this.eventTarget.removeEventListener('swiper:loaded', initialize);
            this.onReady = null;
          }
          return;
        }
        this.eventTarget.removeEventListener('swiper:loaded', initialize);
        this.onReady = null;
        this.instance = new Swiper(inner, {
          slidesPerView: options.columns, spaceBetween: options.spacing, speed: 600,
          grabCursor: complementary, watchOverflow: true, observer: true, observeParents: true,
          navigation: previous && next && !complementary ? { nextEl: next, prevEl: previous } : false,
          pagination: pagination ? { el: pagination, clickable: true } : false,
          breakpoints: strategy(options),
        });
      };
      this.onReady = initialize;
      this.eventTarget.addEventListener('swiper:loaded', initialize);
      initialize();
    }

    destroy() {
      this.cancel(this.timer);
      if (this.onReady) this.eventTarget.removeEventListener('swiper:loaded', this.onReady);
      this.instance?.destroy(true, true);
      this.instance = null;
      this.inner = null;
      this.onReady = null;
    }
  }

  const api = { RecommendationSlider, breakpointStrategies };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.HOMRecommendationSlider = api;
})();
